import { MDSDropdown } from '@marqvision/mds-v2';
import { useDomainNamesCommentFilterQuery } from '~/apis/domainNames';
import { DropDown } from '~/components/Filters/@types';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/DomainNames/@hooks/useTab';
import { useRequest } from '~/pages/DomainNames/List/@hooks/useRequest';
import { MarqCommonEnumsCommentCommentUserTypeEnum } from '~/swagger/data-contracts';
import { parseDropDown, parseValueToValueArray } from '~/utils';
import { ResponsiveProps } from '../Responsive/@types';

export const DomainNamesCommentFilter = ({ size = 'medium' }: ResponsiveProps) => {
  const { request, onCommentUserTypeChange } = useRequest();
  const { amplitudeLogging } = useLogger();
  const { currentTabGroup } = useTab();

  const commentUserTypeFilter = parseValueToValueArray(request.comment_user_type_filter);
  const selected =
    commentUserTypeFilter?.length === 2
      ? MarqCommonEnumsCommentCommentUserTypeEnum.All
      : commentUserTypeFilter?.[0] || null;

  const commentQuery = useDomainNamesCommentFilterQuery<DropDown<MarqCommonEnumsCommentCommentUserTypeEnum>>(request, {
    select: parseDropDown,
  });

  const handleSelect = (nextValue: MarqCommonEnumsCommentCommentUserTypeEnum | null) => {
    if (nextValue) {
      amplitudeLogging('applied filter', {
        Type: 'comments',
        Channel: 'domain names',
        Page: currentTabGroup.replace(/-/g, ' '),
      });

      if (nextValue === MarqCommonEnumsCommentCommentUserTypeEnum.All) {
        onCommentUserTypeChange([
          MarqCommonEnumsCommentCommentUserTypeEnum.Client,
          MarqCommonEnumsCommentCommentUserTypeEnum.Admin,
        ]);
      } else if (nextValue === MarqCommonEnumsCommentCommentUserTypeEnum.Admin) {
        onCommentUserTypeChange([nextValue]);
      } else {
        onCommentUserTypeChange([]);
      }
    } else {
      onCommentUserTypeChange([]);
    }
  };

  const list = commentQuery.data?.list ?? [];
  const isDisabled = list.length === 0;
  const isFetching = commentQuery.isFetching;

  return (
    <MDSDropdown
      label="Comments"
      value={selected}
      list={list}
      isDisabled={isDisabled}
      isLoading={isFetching}
      onChange={(value: MarqCommonEnumsCommentCommentUserTypeEnum | null) => handleSelect(value)}
      modules={[
        'hide-select-all',
        {
          type: 'filter-button',
          size,
        },
      ]}
    />
  );
};
